<template>
  <div id="home">
    <!-- LOGO & EINLEITUNG DESKTOP (Can't be component because of special scroll-nav behaviour) -->
    <div id="logo-einleitung" class="d-none d-md-block">
      <div id="bc-logo">
        <svg
          width="148px"
          height="115px"
          viewBox="0 0 148 115"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <polygon id="path-1" points="0 0 148 0 148 115 0 115"></polygon>
          </defs>
          <g
            id="Design"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="V01-–-Startseite"
              transform="translate(-15.000000, -29.000000)"
            >
              <g id="Group-3" transform="translate(15.000000, 29.000000)">
                <mask id="mask-2" fill="white">
                  <use xlink:href="#path-1"></use>
                </mask>
                <g id="Clip-2"></g>
                <path
                  d="M142.16367,39.4737666 L142.16367,40.9198545 L142.16367,56.8379023 L142.16367,58.4889911 L142.16367,65.4562536 L139.263561,65.4562536 L139.263561,58.4889911 L132.649424,58.4889911 L132.649424,47.9591443 L132.279965,47.5491424 C132.068846,47.3136683 130.14933,45.2581181 127.568678,45.2581181 C124.990803,45.2581181 123.068509,47.3136683 122.860167,47.5491424 L122.490709,47.9591443 L122.490709,58.4889911 L116.068246,58.4889911 L116.068246,65.4562536 L113.168137,65.4562536 L113.168137,58.4889911 L113.168137,56.8379023 L113.168137,39.4737666 L142.16367,39.4737666 Z M142.16367,71.9858113 L142.16367,73.204736 L142.16367,112.077351 L115.095987,112.077351 L113.168137,112.077351 L113.168137,73.204736 L113.148692,73.204736 L113.148692,70.8416843 L113.654266,70.2737763 C114.270956,69.5895163 119.890612,63.572461 127.493675,63.572461 C135.096738,63.572461 140.716393,69.5895163 141.333083,70.2737763 L142.16367,71.2018212 L142.16367,71.9858113 Z M110.270806,68.3899836 L74.0277788,68.3899836 L37.7847517,68.3899836 L37.7847517,39.4737666 L74.0277788,39.4737666 L110.270806,39.4737666 L110.270806,68.3899836 Z M110.270806,103.093322 L74.0277788,103.093322 L37.7847517,103.093322 L37.7847517,71.2793891 L74.0277788,71.2793891 L110.270806,71.2793891 L110.270806,103.093322 Z M79.5196516,112.077351 L69.9415143,112.077351 L69.9415143,105.985498 L74.0277788,105.985498 L79.5196516,105.985498 L79.5196516,112.077351 Z M34.8846428,56.7824966 L34.8846428,58.4889911 L34.8846428,65.4008479 L31.9873118,65.4008479 L31.9873118,58.4889911 L25.4676227,58.4889911 L25.4676227,47.9591443 L25.0981643,47.5491424 C24.8898232,47.3136683 22.9675288,45.2581181 20.3896543,45.2581181 C17.8090018,45.2581181 15.8894853,47.3136683 15.6783663,47.5491424 L15.308908,47.9591443 L15.308908,58.4889911 L8.7447727,58.4889911 L8.7447727,65.4008479 L5.84466384,65.4008479 L5.84466384,58.4889911 L5.84466384,56.7824966 L5.84466384,40.9198545 L5.84466384,39.4737666 L34.8846428,39.4737666 L34.8846428,56.7824966 Z M34.8846428,71.9858113 L34.8846428,73.2518308 L34.8846428,112.077351 L5.84466384,112.077351 L5.84466384,73.2518308 L5.84466384,71.9858113 L5.84466384,70.8860089 L6.35023837,70.3208711 C6.96692819,69.6338408 12.5865836,63.6195558 20.1924246,63.6195558 C27.7927099,63.6195558 33.4151432,69.6338408 34.0290551,70.3208711 L34.8846428,71.2738485 L34.8846428,71.9858113 Z M16.9867488,11.5659327 L23.7897819,11.5659327 L34.7540824,36.5815909 L5.96966853,36.5815909 L16.9867488,11.5659327 Z M50.8324637,22.6609173 L51.201922,22.2481451 C51.3797064,22.051455 52.9936559,20.3227982 55.182627,20.3227982 C57.3688202,20.3227982 58.9855475,22.051455 59.1605541,22.2481451 L59.5327903,22.6609173 L59.5327903,32.8333976 L50.8324637,32.8333976 L50.8324637,22.6609173 Z M81.2752731,22.6609173 L81.6475093,22.2481451 C81.8225159,22.051455 83.4392432,20.3227982 85.6254364,20.3227982 C87.8144074,20.3227982 89.4283569,22.051455 89.6061414,22.2481451 L89.9755997,22.6609173 L89.9755997,32.8333976 L81.2752731,32.8333976 L81.2752731,22.6609173 Z M95.7758174,22.6609173 L96.1452757,22.2481451 C96.3202823,22.051455 97.9370096,20.3227982 100.123203,20.3227982 C102.306618,20.3227982 103.926123,22.051455 104.103908,22.2481451 L104.473366,22.6609173 L104.473366,32.8333976 L95.7758174,32.8333976 L95.7758174,22.6609173 Z M124.265776,11.5659327 L131.068809,11.5659327 L142.030331,36.5815909 L113.301475,36.5815909 L124.265776,11.5659327 Z M145.063779,39.4737666 L145.063779,39.4737666 L148,39.4737666 L148,36.5815909 L145.063779,36.5815909 L145.063779,36.27963 L132.963324,8.67375699 L129.118736,8.67375699 L129.118736,2.89217576 L126.218627,2.89217576 L126.218627,8.50199942 L109.162431,0 L75.4778333,0 L72.5777244,0 L38.8931266,0 L21.8397087,8.50199942 L21.8397087,2.89217576 L18.9395998,2.89217576 L18.9395998,8.67375699 L15.0922332,8.67375699 L2.93899921,36.27963 L2.93899921,36.5815909 L0,36.5815909 L0,39.4737666 L2.99177897,39.4737666 L2.94455498,39.4737666 L2.94455498,68.3899836 L0,68.3899836 L0,71.2793891 L2.94455498,71.2793891 L2.94455498,112.077351 L0,112.107824 L0,115 L108.976313,114.969527 L115.095987,114.969527 L148,114.969527 L148,112.077351 L145.063779,112.077351 L145.063779,71.2793891 L148,71.2793891 L148,68.3899836 L145.063779,68.3899836 L145.063779,40.9198545 L145.063779,39.4737666 Z M127.568678,77.0637406 C124.990803,77.0637406 123.068509,79.1192908 122.860167,79.3547649 L122.490709,79.7675371 L122.490709,94.9874735 L132.649424,94.9874735 L132.649424,79.7675371 L132.279965,79.3547649 C132.068846,79.1192908 130.14933,77.0637406 127.568678,77.0637406 L127.568678,77.0637406 Z M20.3896543,77.0637406 C17.8090018,77.0637406 15.8894853,79.1192908 15.6783663,79.3547649 L15.308908,79.7675371 L15.308908,94.9874735 L25.4676227,94.9874735 L25.4676227,79.7675371 L25.0981643,79.3547649 C24.8898232,79.1192908 22.9675288,77.0637406 20.3896543,77.0637406 L20.3896543,77.0637406 Z M104.473366,79.4018597 L104.103908,78.9890875 C103.926123,78.7923974 102.306618,77.0637406 100.123203,77.0637406 C97.9370096,77.0637406 96.3202823,78.7923974 96.1452757,78.9918578 L95.7758174,79.4018597 L95.7758174,94.9874735 L104.473366,94.9874735 L104.473366,79.4018597 Z M89.9755997,79.4018597 L89.6061414,78.9890875 C89.4283569,78.7923974 87.8144074,77.0637406 85.6254364,77.0637406 C83.4392432,77.0637406 81.8225159,78.7923974 81.6475093,78.9918578 L81.2752731,79.4018597 L81.2752731,94.9874735 L89.9755997,94.9874735 L89.9755997,79.4018597 Z M24.3675814,22.2481451 C24.1897969,22.051455 22.5730696,20.3227982 20.3896543,20.3227982 C18.2034611,20.3227982 16.5867337,22.051455 16.4061714,22.2481451 L16.0422689,22.6609173 L16.0422689,32.8333976 L24.7398176,32.8333976 L24.7398176,22.6609173 L24.3675814,22.2481451 Z M131.646608,22.2481451 C131.468824,22.051455 129.852097,20.3227982 127.665903,20.3227982 C125.47971,20.3227982 123.865761,22.051455 123.687976,22.2481451 L123.318518,22.6609173 L123.318518,32.8333976 L132.018845,32.8333976 L132.018845,22.6609173 L131.646608,22.2481451 Z M62.4301213,45.2581181 C60.246706,45.2581181 58.6272007,46.9867749 58.4494163,47.183465 L58.079958,47.5962372 L58.079958,61.3174504 L66.7775067,61.3174504 L66.7775067,47.5962372 L66.4080484,47.183465 C66.2330418,46.9867749 64.6163144,45.2581181 62.4301213,45.2581181 L62.4301213,45.2581181 Z M47.9323548,45.2581181 C45.7461616,45.2581181 44.1322122,46.9867749 43.9544277,47.183465 L43.5849694,47.5962372 L43.5849694,61.3174504 L52.285296,61.3174504 L52.285296,47.5962372 L51.9130598,47.183465 C51.7352753,46.9867749 50.118548,45.2581181 47.9323548,45.2581181 L47.9323548,45.2581181 Z M104.473366,47.5962372 L104.103908,47.183465 C103.926123,46.9867749 102.306618,45.2581181 100.123203,45.2581181 C97.9370096,45.2581181 96.3202823,46.9867749 96.1452757,47.183465 L95.7758174,47.5962372 L95.7758174,61.3174504 L104.473366,61.3174504 L104.473366,47.5962372 Z M89.9755997,47.5962372 L89.6061414,47.183465 C89.4283569,46.9867749 87.8144074,45.2581181 85.6254364,45.2581181 C83.4392432,45.2581181 81.8225159,46.9867749 81.6475093,47.183465 L81.2752731,47.5962372 L81.2752731,61.3174504 L89.9755997,61.3174504 L89.9755997,47.5962372 Z M62.4301213,77.0637406 C60.246706,77.0637406 58.6272007,78.7923974 58.4494163,78.9918578 L58.079958,79.4018597 L58.079958,94.9874735 L66.7775067,94.9874735 L66.7775067,79.4018597 L66.4080484,78.9890875 C66.2330418,78.7923974 64.6163144,77.0637406 62.4301213,77.0637406 L62.4301213,77.0637406 Z M47.9323548,77.0637406 C45.7461616,77.0637406 44.1322122,78.7923974 43.9544277,78.9918578 L43.5849694,79.4018597 L43.5849694,94.9874735 L52.285296,94.9874735 L52.285296,79.4018597 L51.9130598,78.9890875 C51.7352753,78.7923974 50.118548,77.0637406 47.9323548,77.0637406 L47.9323548,77.0637406 Z"
                  id="Fill-1"
                  fill="#223976"
                  mask="url(#mask-2)"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="type-l" id="einleitung-fixed">
        <a v-smooth-scroll href="#einleitung-section">
          <span v-if="$i18n.locale == 'default'">Einleitung</span>
          <span v-else>Introduction</span>
        </a>
      </div>
    </div>

    <!-- DESKTOP NAV (Can't be component because of special scroll-nav behaviour) -->
    <div id="nav-fixed" ref="desktopNavFixed" class="d-none d-md-block">
      <div class="type-l" id="team-fixed">
        <a v-smooth-scroll href="#team-section">Team</a>
      </div>
      <div class="type-l" id="projekte-fixed">
        <a v-smooth-scroll href="#projekte-section">
          <span v-if="$i18n.locale == 'default'">Projekte</span>
          <span v-else>Projects</span>
        </a>
      </div>
      <div class="type-l" id="publikationen-fixed">
        <a v-smooth-scroll href="#publikationen-section">
          <span v-if="$i18n.locale == 'default'">Publikationen</span>
          <span v-else>Publications</span>
        </a>
      </div>
      <div class="type-l" id="mitglieder-fixed">
        <a v-smooth-scroll href="#mitglieder-section">
          <span v-if="$i18n.locale == 'default'">Verein</span>
          <span v-else>Association</span>
        </a>
      </div>
      <div class="type-l" id="kontakt-fixed">
        <a v-smooth-scroll href="#kontakt-section">
          <span v-if="$i18n.locale == 'default'">Kontakt</span>
          <span v-else>Contact</span>
        </a>
      </div>
      <div class="type-xs" id="lang-switch">
        <span @click="switchLang('default')">DE</span> /
        <span @click="switchLang('english')">EN</span>
      </div>
    </div>

    <!-- NAVIGATION MOBILE -->
    <NavigationMobile
      class="d-block d-md-none"
      :switchLang="switchLang"
    ></NavigationMobile>

    <!-- CONTENT -->
    <b-container fluid>
      <b-row>
        <!-- EINLEITUNG -->
        <b-col cols="12" md="8" offset="0" offset-md="4">
          <Einleitung id="einleitung-section" :entries="entries"></Einleitung>
        </b-col>

        <!-- TEAM LINKS -->
        <b-col cols="4" class="d-none d-md-block nav-sticky" id="team-sticky">
          <div class="type-l">
            <a v-smooth-scroll href="#team-section">Team</a>
          </div>
        </b-col>

        <b-col cols="12" md="8">
          <TeamLinks id="team-section" :entries="entries"></TeamLinks>
        </b-col>

        <!-- PROJEKTE -->
        <b-col
          cols="4"
          class="d-none d-md-block nav-sticky"
          id="projekte-sticky"
        >
          <div class="type-l">
            <a v-smooth-scroll href="#projekte-section">
              <span v-if="$i18n.locale == 'default'">Projekte</span>
              <span v-else>Projects</span>
            </a>
          </div>
        </b-col>

        <b-col cols="12" md="8">
          <ProjekteLinks
            id="projekte-section"
            :entries="entries"
          ></ProjekteLinks>
        </b-col>

        <!-- PUBLIKATIONEN -->
        <b-col
          cols="4"
          class="d-none d-md-block nav-sticky"
          id="publikationen-sticky"
        >
          <div class="type-l">
            <a v-smooth-scroll href="#publikationen-section">
              <span v-if="$i18n.locale == 'default'">Publikationen</span>
              <span v-else>Publications</span>
            </a>
          </div>
        </b-col>

        <b-col cols="12" md="8">
          <Publikationen
            id="publikationen-section"
            :entries="entries"
          ></Publikationen>
        </b-col>

        <!-- MITGLIEDER -->
        <b-col
          cols="4"
          class="d-none d-md-block nav-sticky"
          id="mitglieder-sticky"
        >
          <div class="type-l">
            <a v-smooth-scroll href="#mitglieder-section">
              <span v-if="$i18n.locale == 'default'">Verein</span>
              <span v-else>Association</span>
            </a>
          </div>
        </b-col>

        <b-col cols="12" md="8">
          <Mitglieder id="mitglieder-section" :entries="entries"></Mitglieder>
        </b-col>

        <!-- KONTAKT -->
        <b-col
          cols="4"
          class="d-none d-md-block nav-sticky"
          id="kontakt-sticky"
        >
          <div class="type-l">
            <a v-smooth-scroll href="#kontakt-section">
              <span v-if="$i18n.locale == 'default'">Kontakt</span>
              <span v-else>Contact</span>
            </a>
          </div>
        </b-col>

        <b-col cols="12" md="8">
          <Kontakt id="kontakt-section" :entries="entries"></Kontakt>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Einleitung from "@/components/Home/Einleitung";
import Mitglieder from "@/components/Home/Mitglieder";
import TeamLinks from "@/components/Home/TeamLinks";
import ProjekteLinks from "@/components/Home/ProjekteLinks";
import Publikationen from "@/components/Home/Publikationen";
import Kontakt from "@/components/Home/Kontakt";
import NavigationMobile from "@/components/Shared/NavigationMobile";

const axios = require("axios");

export default {
  name: "Home",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Basel Academy",
    // all titles will be injected into this template
    description:
      "Die Basel Academy ist ein wissenschaftliches Institut und Dienstleister in den Bereichen Qualitätsmessung, Versorgungsforschung und klinische Forschung.",
  }),
  components: {
    Einleitung,
    Mitglieder,
    TeamLinks,
    ProjekteLinks,
    Publikationen,
    Kontakt,
    NavigationMobile,
  },
  data() {
    return {
      entries: {},
    };
  },
  created() {
    let credits = `
        __               __                     __
       |  |      ___    |  |                   |  | 
       |  |     /__/    |  |                   |  |   ___
 ______|  |  _________  |  | ____   ___    ___ |  |__/__/
/  /   |  | /   /  |  | |   / |  | /  /   |  | |  |
|  |   |  | |  |___|__/ |  |  |  | |  |   |  | |  |
|  |   |  | |  |    ___ |  |  |  | |  |   |  | |  |   ___
|__|__/__/| |__|___/__/ |__|__/__/ |__|__/__/| |__|__/__/
        __               __                     __
       |  |      ___    |  |                   |  | 
       |  |     /__/    |  |                   |  |   ___
 ______|  |  _________  |  | ____   ___    ___ |  |__/__/
/  /   |  | /   /  |  | |   / |  | /  /   |  | |  |
|  |   |  | |  |___|__/ |  |  |  | |  |   |  | |  |
|  |   |  | |  |    ___ |  |  |  | |  |   |  | |  |   ___
|__|__/__/| |__|___/__/ |__|__/__/ |__|__/__/| |__|__/__/

Hello fellow digital nativ!  
This site was made by Début Début (Alain Brusch, Max Frischknecht, Philipp Möckli & Adrian Schnegg) in 2021
https://debutdebut.com
`;

    console.log(credits);
  },
  mounted() {
    // start the ScrollMagic Code
    this.apiCall();
    this.hideNavElement();
    this.detectCurrentSection();
  },
  methods: {
    detectCurrentSection() {
      const vm = this;

      const einleitungSection = vm.$scrollmagic
        .scene({
          triggerElement: "#einleitung-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#einleitung-section")
            vm.$router.push("#einleitung-section");
        });
      vm.$scrollmagic.addScene(einleitungSection);

      const mitgliederSection = vm.$scrollmagic
        .scene({
          triggerElement: "#mitglieder-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#mitglieder-section")
            vm.$router.push("#mitglieder-section");
        });
      vm.$scrollmagic.addScene(mitgliederSection);

      const teamSection = vm.$scrollmagic
        .scene({
          triggerElement: "#team-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#team-section")
            vm.$router.push("#team-section");
        });
      vm.$scrollmagic.addScene(teamSection);

      const projekteSection = vm.$scrollmagic
        .scene({
          triggerElement: "#projekte-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#projekte-section")
            vm.$router.push("#projekte-section");
        });
      vm.$scrollmagic.addScene(projekteSection);

      const publikationenSection = vm.$scrollmagic
        .scene({
          triggerElement: "#publikationen-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#publikationen-section")
            vm.$router.push("#publikationen-section");
        });
      vm.$scrollmagic.addScene(publikationenSection);

      const kontaktSection = vm.$scrollmagic
        .scene({
          triggerElement: "#kontakt-section",
        })
        .on("start", () => {
          if (vm.$router.history.current.hash !== "#kontakt-section")
            vm.$router.push("#kontakt-section");
        });
      vm.$scrollmagic.addScene(kontaktSection);
    },
    hideNavElement() {
      // get all measurments for the right offsets:
      let bottomNavHeight = this.$refs.desktopNavFixed.clientHeight;
      let navElHeight = 39; // must match the css element height below!

      // Declare Scene
      const mitgliederScene = this.$scrollmagic
        .scene({
          // ID of element where animation starts
          triggerElement: "#mitglieder-sticky",
          triggerHook: 1,
        })
        .setClassToggle("#mitglieder-fixed", "d-none")
        // .addIndicators()
        .offset(bottomNavHeight);
      this.$scrollmagic.addScene(mitgliederScene);

      const teamScene = this.$scrollmagic
        .scene({
          triggerElement: "#team-sticky",
          triggerHook: 1,
        })
        .setClassToggle("#team-fixed", "d-none")
        // .addIndicators()
        .offset(bottomNavHeight - navElHeight);
      this.$scrollmagic.addScene(teamScene);

      const projekteScene = this.$scrollmagic
        .scene({
          triggerElement: "#projekte-sticky",
          triggerHook: 1,
        })
        .setClassToggle("#projekte-fixed", "d-none")
        // .addIndicators()
        .offset(bottomNavHeight - navElHeight * 2);
      this.$scrollmagic.addScene(projekteScene);

      const publikationenScene = this.$scrollmagic
        .scene({
          triggerElement: "#publikationen-sticky",
          triggerHook: 1,
        })
        .setClassToggle("#publikationen-fixed", "d-none")
        // .addIndicators()
        .offset(bottomNavHeight - navElHeight * 3);
      this.$scrollmagic.addScene(publikationenScene);

      const kontaktScene = this.$scrollmagic
        .scene({
          triggerElement: "#kontakt-sticky",
          triggerHook: 1,
        })
        .setClassToggle("#kontakt-fixed", "d-none")
        // .addIndicators()
        .offset(bottomNavHeight - navElHeight * 4);
      this.$scrollmagic.addScene(kontaktScene);
    },
    switchLang(newLang) {
      this.$i18n.locale = newLang;
      this.apiCall();
    },
    apiCall() {
      // GRAPH QL CALL
      axios({
        url: "https://backend.basel-academy.ch/api",
        method: "POST",
        data: {
          query: `
            query {
              entries(section: "startseite", site: "${this.$i18n.locale}") {
                ... on startseite_startseite_Entry {
                  titel
                  einleitungStartseite
                  einleitungVorstand
                  vorstand {
                    ... on vorstand_zwischentitel_BlockType {
                      __typename
                      zwischentitel
                    }
                    ... on vorstand_person_BlockType {
                      __typename
                      person
                      institution
                    }
                    ... on vorstand_teamMemberMitLink_BlockType {
                      __typename
                      teamMemberMitLink {
                        ... on team_team_Entry {
                          institution
                          title
                          slug
                        }
                      }
                    }
                  }
                  einleitungMitglieder
                  mitglieder {
                    ... on mitglieder_person_BlockType {
                      __typename
                      person
                      institution
                    }
                    ... on mitglieder_teamMemberMitLink_BlockType {
                      __typename
                      teamMemberMitLink {
                        ... on team_team_Entry {
                          institution
                          title
                          slug
                        }
                      }
                    }
                  }
                  einleitungTeamLinks
                  teamLinks {
                    title
                    slug
                    ... on team_team_Entry {
                      kompetenzen {
                        kompetenz
                      }
                    }
                  }
                  einleitungProjekte
                  projekteLinks {
                    title
                    slug
                  }
                  einleitungPublikationen
                  publikationen {
                    ... on publikationen_publikation_BlockType {
                      __typename
                      bibliografischeAngabe
                    }
                  }
                  einleitungKontakt
                  email
                }
              }
            }
          `,
        },
      }).then((result) => {
        let data = result.data.data.entries[0];
        this.entries = data;
      });
    },
  },
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";

// equals to the line-height between the nav elements on the top
// must match the number in method hideNavElement => navElHeight
// used in #nav-fixed, .nav-sticky, #einleitung-fixed
$el-height: 3.9rem; // 3.2
$starting-pos: 20.2rem; // 19.5

#logo-einleitung {
  position: fixed;
  top: 0;
  left: 0;
  margin-top: 0.8rem;
  margin-left: 1.5rem;
}

#einleitung-fixed {
  height: $el-height;
}

#bc-logo {
  padding-top: 2.3rem;
  padding-bottom: 1.6rem;
}

#nav-fixed {
  position: fixed;
  width: 33%;
  background-color: white;
  bottom: 0;
  left: 0;
  padding-left: 1.5rem;
  padding-bottom: 1rem;
  width: calc(33.3333333% - 3rem);
  z-index: 100;
  & div {
    height: $el-height;
  }
}

#lang-switch span {
  cursor: pointer;
}

#einleitung-fixed {
  height: $el-height;
}

.nav-sticky {
  position: sticky !important;
  position: -webkit-sticky; /* Safari */
  height: $el-height;
}

#team-sticky {
  top: $starting-pos;
}
#projekte-sticky {
  top: $starting-pos + $el-height;
}
#publikationen-sticky {
  top: $starting-pos + ($el-height * 2);
}
#mitglieder-sticky {
  top: $starting-pos + ($el-height * 3);
}
#kontakt-sticky {
  top: $starting-pos + ($el-height * 4);
}
</style>
